import { useQuery } from '@tanstack/react-query';
import {
  CategorySubCategory,
  getAllCategoriesSubCategoriesByCategoryType
} from 'api/categories/_requests';
import Section from 'components/base/Section';
import CategoryItem from 'components/common/CategoryItem';
import CategorySubCategoryList from 'components/common/CategorySubCategoryList';
import React from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';

const CategoriesPage = () => {
  const {
    data: catSubCategories,
    isLoading,
    isError
  } = useQuery<CategorySubCategory[]>({
    queryKey: ['all-categories'],
    queryFn: getAllCategoriesSubCategoriesByCategoryType
  });

  return (
    <div className="pt-5 mb-9">
      <Container className="px-xl-0 px-xxl-3">
        <Row className="g-3">
          {isLoading ? (
            <div className="text-center py-5">
              <Spinner animation="border" role="status" />
              <p className="mt-3">Loading categories...</p>
            </div>
          ) : (
            catSubCategories?.slice(0, 12).map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={4}>
                <CategoryItem categorySubCategory={item} />
              </Col>
            ))
          )}
        </Row>
        <div className="mb-5 mt-3">
          <h4>All Categories</h4>
        </div>
        <div className="card">
          <div className="card-body">
            {isLoading ? (
              <div className="text-center py-5">
                <Spinner animation="border" role="status" />
                <p className="mt-3">Loading categories...</p>
              </div>
            ) : (
              <Row className="gx-1 gy-5">
                <Col xs={12}>
                  <CategorySubCategoryList
                    categorySubCategory={catSubCategories || []}
                  />
                </Col>
              </Row>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CategoriesPage;
